<template>
  <!--  <button v-on:click="selected" class="e4s-tab-link&#45;&#45;default" :class="getClasses">-->
  <!--    <slot>-->
  <!--      <span v-text="linkTitle" class="e4s-header&#45;&#45;400"></span>-->
  <!--    </slot>-->
  <!--  </button>-->
  <ul v-on:click="selected" class="e4s-tab-link--default" :class="getClasses">
    <slot> <span v-text="linkTitle" class="e4s-header--400"></span>{{ debug }} </slot>
  </ul>
</template>

<script lang="ts">
import { computed, defineComponent, onUpdated, ref, type SetupContext } from 'vue'
import { useConfigController } from '@/config/useConfigStore'

export default defineComponent({
  name: 'section-link-simple',
  components: {},
  props: {
    linkTitle: {
      type: String,
      default: ''
    },
    linkId: {
      type: String,
      default: ''
    },
    isActive: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    isDisabled: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    isSecondary: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  setup(
    props: {
      linkTitle: string
      isActive: boolean
      isDisabled: boolean
      isSecondary: boolean
    },
    context: SetupContext
  ) {
    const everBeenClicked = ref(false)

    const configController = useConfigController()

    onUpdated(() => {
      console.log('section-link-simple ' + '...updated! ' + new Date().toISOString())
    })

    function selected() {
      if (!props.isDisabled) {
        everBeenClicked.value = true
        context.emit('selected')
      }
    }

    const getClasses = computed(() => {
      const cssEnv = configController.getCssEnvSuffix.value //  E.g. AAI = "ai-", UK = ""  e4s-hyperlink--ia-primary

      const cssClasses = []

      // const cssClasses = [];
      if (props.isActive) {
        cssClasses.push('e4s-tab-link--' + cssEnv + 'selected')
        // cssClasses.push('e4s-tab-link--sub-default--selected')
      }
      if (props.isDisabled) {
        cssClasses.push('e4s-tab-link--disabled')
      }
      return cssClasses
    })

    const debug = computed(() => {
      return configController.getCssEnvSuffix.value
    })

    return { debug, selected, getClasses, configController }
  }
})
</script>
